import React, { useState } from 'react';
import { api, formatApiError } from '../lib/api';
import { QrCode, Download, Printer, ExternalLink } from 'lucide-react';
import { Modal } from '../lib/Modal';

export function MenuQrCard({ restaurantName }) {
    const [open, setOpen] = useState(false);
    const [qr, setQr] = useState(null);
    const [loading, setLoading] = useState(false);

    const openQr = async () => {
        setOpen(true);
        if (qr) return;
        setLoading(true);
        try {
            const { data } = await api.get('/r/menu-qr');
            setQr(data);
        } catch (e) {
            alert(formatApiError(e));
            setOpen(false);
        } finally {
            setLoading(false);
        }
    };

    const printQr = () => {
        if (!qr) return;
        const win = window.open('', '_blank', 'width=520,height=680');
        if (!win) {
            alert('Permite ferestrele pop-up pentru a printa QR-ul.');
            return;
        }
        const title = restaurantName || qr.restaurant_name || 'Meniu';
        win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>QR Meniu — ${title}</title>
            <style>
              *{box-sizing:border-box}
              body{font-family:Arial,Helvetica,sans-serif;text-align:center;padding:40px 24px;color:#111;margin:0}
              h1{font-size:26px;margin:0 0 6px}
              p{color:#555;margin:0 0 28px;font-size:15px}
              img{width:340px;height:340px}
              .hint{margin-top:22px;font-size:13px;color:#777;word-break:break-all}
              @media print{.noprint{display:none}}
            </style></head><body>
              <h1>${title}</h1>
              <p>Scanează codul pentru a vedea meniul</p>
              <img src="${qr.qr_base64}" alt="QR Meniu" />
              <div class="hint">${qr.url || ''}</div>
              <script>window.onload=function(){setTimeout(function(){window.print();},150);}</script>
            </body></html>`);
        win.document.close();
    };

    return (
        <>
            <div
                className="panel"
                style={{
                    marginBottom: '1.4rem',
                    display: 'flex',
                    gap: '1rem',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    background: 'rgba(245,158,11,0.05)',
                    border: '1px solid rgba(245,158,11,0.28)',
                }}
                data-testid="menu-qr-card"
            >
                <div style={{
                    width: 46, height: 46, borderRadius: 12, flexShrink: 0,
                    background: 'rgba(245,158,11,0.12)', border: '1px solid rgba(245,158,11,0.4)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    <QrCode size={22} color="var(--amber)" />
                </div>
                <div style={{ flex: 1, minWidth: 200 }}>
                    <div style={{ fontWeight: 600 }}>Meniu QR</div>
                    <p style={{ margin: '2px 0 0', color: 'var(--text-muted)', fontSize: '0.88rem', lineHeight: 1.45 }}>
                        Codul QR unic al restaurantului. Clienții îl scanează și văd meniul. Descarcă-l sau printează-l pentru masă.
                    </p>
                </div>
                <button type="button" className="btn btn-primary" onClick={openQr} data-testid="open-menu-qr">
                    <QrCode size={16} /> Vezi QR Meniu
                </button>
            </div>

            <Modal open={open} onClose={() => setOpen(false)} title="Meniu QR">
                {loading || !qr ? (
                    <div style={{ textAlign: 'center', padding: '2rem 0' }}>
                        <div className="spinner" style={{ margin: '0 auto' }} />
                    </div>
                ) : (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ background: '#fff', padding: 16, borderRadius: 12, display: 'inline-block' }}>
                            <img src={qr.qr_base64} alt="QR Meniu" style={{ width: 240, height: 240, display: 'block' }} data-testid="menu-qr-image" />
                        </div>
                        <div style={{ marginTop: '1rem', color: 'var(--text-muted)', fontSize: '0.82rem', wordBreak: 'break-all' }}>
                            {qr.url}
                        </div>
                        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: '1.2rem', flexWrap: 'wrap' }}>
                            <a href={qr.qr_base64} download="meniu-qr.png" className="btn btn-secondary" data-testid="menu-qr-download">
                                <Download size={16} /> Descarcă PNG
                            </a>
                            <button type="button" className="btn btn-primary" onClick={printQr} data-testid="menu-qr-print">
                                <Printer size={16} /> Printează
                            </button>
                            <a href={qr.url} target="_blank" rel="noreferrer" className="btn btn-ghost" data-testid="menu-qr-open">
                                <ExternalLink size={16} /> Deschide meniul
                            </a>
                        </div>
                    </div>
                )}
            </Modal>
        </>
    );
}
